import { MetadataFieldRendererProps } from '@/asset/components/metadata/field-renderer';
import { MINIMUM_DATE } from '@/constants/date-shortcut';
import { DateTimePicker } from '@mui/x-date-pickers-pro';
import { DateTime } from 'luxon';
import { FieldValues, useFormContext, useWatch } from 'react-hook-form';

/**
 * Renders a date-time field in the metadata form.
 *
 * IMPORTANT: This component must be wrapped in a FormProvider from react-hook-form.
 */
export function DateTimeFieldRenderer(props: MetadataFieldRendererProps) {
  const { metadata, setValue, error, fieldIndex } = props;
  const { control } = useFormContext<FieldValues>();
  const value = useWatch({
    control,
    name: `metadata.${fieldIndex}.value`,
  });
  return (
    <DateTimePicker
      label={metadata.field.label}
      views={['year', 'month', 'day', 'hours', 'minutes']}
      value={
        value ? DateTime.fromFormat(String(value), 'yyyy-MM-dd HH:mm:ss') : null
      }
      onChange={(newValue: DateTime | null) => {
        const formattedValue = newValue
          ? newValue.toFormat('yyyy-MM-dd HH:mm:ss')
          : null;
        setValue(formattedValue);
      }}
      minDate={MINIMUM_DATE}
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          error: !!error,
          helperText: error?.message,
        },
        actionBar: {
          actions: ['clear', 'accept'],
        },
      }}
    />
  );
}
